<template>
    <i
        class="iconfont"
        :class="'icon-' + props.icon"
        :style="{ fontSize: computedSize, color: props.color }"></i>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { pxToRem } from '@/utils/rem/rem';

const props = withDefaults(
    defineProps<{
        icon: string;
        size?: number | string;
        color?: string;
    }>(),
    {
        size: 20,
        color: ''
    }
);

// 将 px 转换为 rem
const computedSize = computed(() => {
    return pxToRem(props.size);
});
</script>

<style lang="scss" scoped>
.iconfont {
    display: inline-block;
}
</style>
